const superscriptPattern =
  /\^\(\s*([A-Za-z0-9+\-− ]{1,20})\s*\)|\^([+\-−]?\d+|[A-Za-z])/g;

function normaliseExponent(exponent) {
  return String(exponent)
    .trim()
    .replace(/-/g, "−");
}

export function formatMathematicsHtml(value) {
  return String(value ?? "").replace(
    superscriptPattern,
    (match, groupedExponent, simpleExponent) =>
      `<sup>${normaliseExponent(
        groupedExponent ?? simpleExponent
      )}</sup>`
  );
}

